import {
  MINIMUM_SESSION_TIME,
  SAVE_SESSION_RATE,
  TIME_FOR_SESSION_STOP,
  TRACKED_EVENTS,
  TRACKED_PAGES,
  TRACKING_REFRESH_RATE
} from "./TimeTrackingTypes";
import {BackEndService} from "../../../../utils/BackEndService";
import {midiDispatcher} from "../../../midi/MidiDispatcher";
import {generateRandomString} from "../../../../utils/string";
import {userEventController} from "../../UserEventController";
import router from "../../../../router";
import audioPlayer from "../../../synth/AudioPlayer";
import Vue from 'vue';

class TimeTrackingController {
  private lastActionTime : number = 0
  private trackingLoopInterval : number = 0
  private regularSaveInterval : number = 0
  private trackingSessionId : string = ''

  public state = Vue.observable({
    isTrackingActive: false,
    currentPlayableStartTime: 0,
    additionalData: {
      time: 0,
      trials_count: 1,
      tempo_increase: 0,
      tempo_decrease: 0,
    },
    logActions: {}
  })

  public startTracking(){
    if(this.state.isTrackingActive){
      return
    }
    this.state.isTrackingActive = true
    sessionStorage.setItem("sessionStartTime", Date.now().toString())
    this.state.currentPlayableStartTime = Date.now()
    TRACKED_EVENTS.forEach((evt: any) => document.addEventListener(evt, this.activeUserListener.bind(this)));
    midiDispatcher.on('notePlayed', this.activeUserListener.bind(this));
    this.trackingLoopInterval = setInterval(this.checkLastActivity.bind(this), TRACKING_REFRESH_RATE) as unknown as number
    this.regularSaveInterval = setInterval(this.sendTrackingData.bind(this), SAVE_SESSION_RATE) as unknown as number
    this.trackingSessionId = sessionStorage.trackingSessionTokatab;
    this.setTrackingSessionId()
    router.afterEach(this.saveActions.bind(this))
  }

  private activeUserListener() {
    if(this.state.isTrackingActive){
      if (audioPlayer.state.playerStatus !== 'pause') {
        this.lastActionTime = Date.now();
      }
    }
    else {
      this.startTracking()
      clearInterval(this.trackingLoopInterval)
    }
  }

  public checkLastActivity() {
    if(!this.state.isTrackingActive || !sessionStorage.sessionStartTime || this.lastActionTime === 0 || this.lastActionTime > Date.now()){
      return
    }
    if(Date.now() - this.lastActionTime > TIME_FOR_SESSION_STOP){
      if(Math.ceil((this.lastActionTime - parseInt(sessionStorage.sessionStartTime!)) / 1000) > MINIMUM_SESSION_TIME){
        this.sendTrackingData()
      }
      TRACKED_EVENTS.forEach((evt: any) => document.removeEventListener(evt, this.activeUserListener));
      midiDispatcher.off('notePlayed', this.activeUserListener);
      sessionStorage.removeItem("sessionStartTime")
      clearInterval(this.regularSaveInterval)
      if(!TRACKED_PAGES.includes(router.currentRoute.name!)) {
        clearInterval(this.trackingLoopInterval);
      }
      this.state.isTrackingActive = false
    }
    if(Math.ceil((this.lastActionTime - parseInt(sessionStorage.sessionStartTime!)) / 1000) > 600){
      userEventController.newActivity("CONNECTION", null, null, {})
    }
  }

  private sendTrackingData() {
    if(!this.state.isTrackingActive || !sessionStorage.sessionStartTime || this.lastActionTime === 0 || this.lastActionTime > Date.now()){
      return
    }
    this.saveActions(router.currentRoute, router.currentRoute)
    return BackEndService.sendPostRequest('session', {
      session_token: this.trackingSessionId,
      duration: Math.ceil((this.lastActionTime - parseInt(sessionStorage.sessionStartTime!)) / 1000),
      started_at : (new Date(parseInt(sessionStorage.sessionStartTime))).toISOString().split('T')[0]
        + ' ' + (new Date(parseInt(sessionStorage.sessionStartTime))).toTimeString().split(' ')[0],
      logs: this.state.logActions
    }).then(()=>{
      this.state.logActions = {}
      this.state.additionalData = {time: 0, trials_count: 1, tempo_increase: 0, tempo_decrease: 0}
    })
  }

  setTrackingSessionId() {
    this.trackingSessionId = generateRandomString(30);
    sessionStorage.setItem('trackingSessionTokatab', this.trackingSessionId);
  }

  saveActions(to: any, from: any) {
    this.state.additionalData.time = Math.ceil((this.lastActionTime - this.state.currentPlayableStartTime) / 1000)
    if((from.name === 'Player' || from.name === 'Player School') && (from.path.split('/')[2] === 'challenge' || from.path.split('/')[2] === 'school')) {
      const objKey = from.path.split('/')[2] + '_' + from.params.playableId;
      if(this.state.logActions[objKey] !== undefined) {
        for (const key in this.state.logActions[objKey]) {
          this.state.logActions[objKey][key] += this.state.additionalData[key];
        }
      }
      else {
        this.state.logActions[objKey] = this.state.additionalData
      }
      this.state.additionalData = {time: 0, trials_count: 1, tempo_increase: 0, tempo_decrease: 0}
    }

    if((to.name === 'Player' || to.name === 'Player School') && (to.path.split('/')[2] === 'challenge' || to.path.split('/')[2] === 'school')) {
      this.state.currentPlayableStartTime = Date.now()
    }
  }

  public getTimeTrackingInfos() {
    this.saveActions(router.currentRoute, router.currentRoute)
    return this.state
  }
}

export const timeTrackingController = new TimeTrackingController()
